import AssemblyDto from '../../dto/assemblies/out/assembly.dto';

const WASTE_TYPES: (keyof AssemblyDto)[] = [
  'wasteWood',
  'wasteConcreteOrBricks',
  'wasteDrywall',
];

class GetWasteTypesFieldService {
  get(assembly: AssemblyDto): string[] {
    const wasteType: string[] = [];

    for (const key of WASTE_TYPES) {
      if (assembly[key as keyof AssemblyDto]) wasteType.push(key);
    }

    return wasteType;
  }
}

export default GetWasteTypesFieldService;
